module.exports = __webpack_public_path__ + "img/msg.fb63473d.svg";